// Version : 0.0.1
// Author : SABARI

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/********** FETCH MANDATORY MEMBER ACCESS START *********** */
export const fetchMandatoryMemberAccessType = (fetchData: any) => {
	const data = {
		MemberMandatoryAccessToken: fetchData,
	};
	const url = `${API_URL}fetchMandatoryMemberAccessTypes`;
	return makeApiCall(url, data);
};
/********** FETCH MANDATORY MEMBER ACCESS END *********** */

/********** UDATE MANDATORY MEMBER ACCESS START *********** */
export const updateMandatoryMemberAccessType = (updateData: any) => {
	const data = {
		MemberMandatoryUpdateToken: updateData,
	};
	const url = `${API_URL}updateMandatoryMember`;
	return makeApiCall(url, data);
};
/********** UDATE MANDATORY MEMBER ACCESS END *********** */
